import { IAutocompleteItem } from './autocomplete-item';
import { CustomDataAdaptor } from '@syncfusion/ej2-data';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { fakeHttpRequest } from '../fakeHttpRequest';

export class AutocompleteCustomAdaptor extends CustomDataAdaptor {
  private search$ = new Subject<{ searchText: string | null; args: any }>();
  private subscription: Subscription;

  constructor(private getDataFunction: (searchText: string) => Observable<string[] | IAutocompleteItem[]>) {
    super();
    this.options.getData = this.getData.bind(this);

    this.subscription = this.search$.pipe(
      debounceTime(400),
      distinctUntilChanged((a, b) => a.searchText === b.searchText),
      switchMap(({ searchText, args }) =>
        this.getDataFunction(searchText).pipe(
          map(result => ({ result, args }))
        )
      )
    ).subscribe(({ result, args }) => {
      args.onSuccess(result, { httpRequest: new fakeHttpRequest() });
    });
  }

  public destroy(): void {
    this.subscription.unsubscribe();
    this.search$.complete();
  }

  private getData(args: any): void {
    const data = JSON.parse(args.data);
    const searchText = data.where ? data.where[0].value : null;
    this.search$.next({ searchText, args });
  }
}
